<template>
  <div class="DataApplicationModel">
    <div class="main">
      <p class="title">数据应用模式</p>
      <p class="sub_title">基于大数据分析的精准用户推广</p>

      <div class="models">
        <img class="img1" :src="img1" />
        <img class="img2" :src="img2" />
        <img class="img3" :src="img3" />
        <img class="img4" :src="img4" />
        <img class="img5" :src="img5" />
      </div>

      <p class="sub_title">截止到目前瑞鹏已拥有</p>

      <ul class="dataArea">
        <li>
          <p class="num">6亿</p>
          <p class="text">可分析且标签化用户</p>
        </li>
        <li>
          <p class="num">2400<span>个</span></p>
          <p class="text">现有标签库</p>
        </li>
        <li>
          <p class="num">1.2亿<span>/天</span></p>
          <p class="text">电商购物类用户</p>
        </li>
        <li>
          <p class="num">2400万<span>/天</span></p>
          <p class="text">金融银证类用户</p>
        </li>
      </ul>

      <p class="remark">
        根据以上标签，到大数据中定向匹配用户，然后推送，再根据效果，取种子用户，
        进行放大/约束，再次定向用户或者优化标签。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataApplicationModel',
  data () {
    return {
      img1: require("@/assets/imgs/img-tec-model-00.png"),
      img2: require("@/assets/imgs/img-tec-model-01.png"),
      img3: require("@/assets/imgs/img-tec-model-02.png"),
      img4: require("@/assets/imgs/img-tec-model-03.png"),
      img5: require("@/assets/imgs/img-tec-model-04.png"),
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" type="text/scss">
  .DataApplicationModel {
    background: rgba(244, 244, 244, 1);
    padding-bottom: 40px;

    .main {
      width: 1200px;
      margin: 0 auto;

      p {
        margin: 0;
        text-align: center;
      }
      >.title {
        font-size:48px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        padding: 40px 0 29px;
      }
      >.sub_title {
        font-size:30px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
      }

      .models {
        position: relative;
        height: 455px;
        margin: 75px 0;

        .img1 {
          width: 456px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          &:hover {
            width: 500px;
          }
        }
        .img2 {
          position: absolute;
          left: 10%;
          top: 8%;
          width: 244px;

          &:hover {
            width: 260px;
            left: 6%;
          }
        }
        .img3 {
          position: absolute;
          left: 70%;
          top: 8%;

          &:hover {
            width: 260px;
            left: 74%;
          }
        }
        .img4 {
          position: absolute;
          left: 70%;
          bottom: 9%;

          &:hover {
            width: 260px;
            left: 74%;
          }
        }
        .img5 {
          position: absolute;
          left: 8%;
          bottom: 9%;

          &:hover {
            width: 290px;
            left: 5%;
          }
        }
      }

      .dataArea {
        display: flex;
        justify-content: center;
        margin: 70px 0;

        li {
          margin: 0 45px;
          .num {
            font-size:60px;
            font-family:PingFangSC-Heavy;
            font-weight:800;
            color:rgba(65,150,255,1);
            line-height: 80px;
            span {
              font-size:24px;
              font-family:PingFangSC-Heavy;
              font-weight:800;
              color:rgba(65,150,255,1);
            }
          }
          .text {
            font-size:24px;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(0,0,0,1);
            line-height: 40px;
          }
        }
      }

      .remark {
        width:705px;
        font-size:20px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:42px;
        margin: 0 auto;
      }

    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Technology_Services/DataApplicationModel.vue